import { define, html, router, store } from "hybrids";

import { PaymentEvent } from "~/modules/website/elements/Stripe";
import { formatPrice } from "~/utils/currency";

import ArtistVideo from "~/stores/ArtistVideo";
import PaymentMethods from "~/stores/PaymentMethods";
import VideoDonation from "~/stores/VideoDonation";

import Confirm from "./Confirm";

interface VVideoDonatePaymentsView extends HTMLElement {
  video?: ArtistVideo;
  payments: PaymentMethods;
  donation?: VideoDonation;
}

function submit(host: VVideoDonatePaymentsView, event: PaymentEvent) {
  store.set(host.donation, { ...event.detail }).then(() => {
    (host.querySelector("#submit-button") as HTMLElement).click();
  });
}

export default define<VVideoDonatePaymentsView>({
  tag: "v-video-donate-payments-view",
  video: store(ArtistVideo),
  payments: store(PaymentMethods, {
    id: ({ video }) => (store.ready(video) ? video?.owner?.id : undefined),
  }),
  donation: store(VideoDonation),
  render: () => html`<slot></slot>`.css`
    :host { display: flex; flex-flow: column;height: 100%;}
    ::slotted(form) { display: flex; flex-flow: column; flex: 1 0 auto; }
  `,
  content: ({ donation, payments, video }) => html`
    <v-broadcast-nav-bar back close>Choose Payment</v-broadcast-nav-bar>

    <form action="${router.url(Confirm, { video: video, status: "succeeded" })}">
      ${donation &&
      store.ready(payments, donation) &&
      html`
        ${store.ready(donation) && store.pending(donation)
          ? html`
              <v-ui-flexbox layout="center center" grow="1">
                <v-ui-icon name="spinner" color=""></v-ui-icon>
                <v-ui-text color="text-secondary" center ygutter="1">
                  Your payment is being processed,
                  <br />
                  please&nbsp;wait...
                  <br />
                  Warning: Navigating back could create a double transaction
                </v-ui-text>
              </v-ui-flexbox>
            `
          : html`
              <v-ui-flexbox gap="medium">
                <v-ui-text variant="h1" ygutter="1">
                  ${formatPrice(donation.total, payments.currency)}
                </v-ui-text>
                ${payments.stripe.account &&
                html`
                  <v-ui-divider>Credit or debit card</v-ui-divider>
                  <v-website-stripe
                    settings="${payments.stripe}"
                    paymentRequest=${donation.paymentRequest}
                    onapprove="${submit}"
                  ></v-website-stripe>
                `}
                ${payments.paypal.clientId &&
                donation.currency !== "INR" &&
                html`
                  <v-website-paypal
                    clientId="${payments.paypal.clientId}"
                    paymentRequest=${donation.paymentRequest}
                    onapprove="${submit}"
                  ></v-website-paypal>
                `}
              </v-ui-flexbox>
            `}
      `}
      <button id="submit-button" type="submit" hidden></button>
    </form>
  `,
});
